"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sample = void 0;
var Sample = /** @class */ (function () {
    function Sample(target, area) {
        this.target = target;
        this.area = area;
    }
    return Sample;
}());
exports.Sample = Sample;
//# sourceMappingURL=Sample.js.map